<template>
    <div class="unconnect-page">
        <title-component v-if="getAllUnhandledNotifications.length === 0">
            Er zijn op dit moment geen alarmeringen
        </title-component>
        <table v-if="getAllUnhandledNotifications.length > 0">
            <thead>
            <tr>
                <th v-for="col in tableColumns" :key="col" class="table-head">{{ col }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="notification in getAllUnhandledNotifications"
                :key="notification.id"
                class="table-row"
                @click="showClientLocationOnMap(notification)">
                <td>{{ notification.smartwatchName }}</td>
                <td v-if="userIsMeldkamerMedewerker">Anoniem</td>
                <td v-else>{{ notification.clientInitials }}</td>
                <td>{{ notification.notificationType }}</td>
                <td>{{ notification.serverTime | toSimpleDateFormat }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { RouteName } from '../utils/enums';
    import { Role } from '../utils/enums';

    export default {
        name: 'notifications-page',
        computed: {
            ...mapGetters(['getAllUnhandledNotifications']),
            userIsMeldkamerMedewerker() {
                return this.$store.getters.getUserGroups.includes(Role.MELDKAMER_MEDEWERKER);
            }
        },
        data: function () {
            return {
                tableColumns: ['Smartwatch', 'Cliënt', 'Type alarmering', 'Tijdstip alarmering'],
                modalHeaderText: 'Alarmering overdragen',
                modalBodyText: 'Weet u zeker dat u de alarmering wilt afhandelen?',
                modalButtonLeft: 'Annuleren',
                modalButtonRight: 'Afhandelen',
                isModalVisible: false
            }
        },
        created() {
            this.$store.dispatch('CLEAR_NEW_NOTIFICATIONS');
            this.$store.dispatch("FETCH_ALL_UNHANDLED_NOTIFICATIONS");
        },
        methods: {
            showClientLocationOnMap(notification) {
                this.$store.dispatch('SET_SELECTED_NOTIFICATION', notification);
                this.$router.push({ name: RouteName.NOTIFICATION_DETAIL });
            }
        }
    };
</script>
<style scoped lang="scss">
    table {
        width: 100%;
        background-color: $white;
    }

    .table-head {
        background-color: $primary;
        color: $white;
    }

    th, td {
        text-align: left;
        padding: 8px;
    }

    tr {
        border-radius: 0.25rem;
        height: 4rem;
        box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
        margin-bottom: 1rem;
        overflow: hidden;
        transition: 0.3s ease all;
    }

    tr:hover td {
        background-color: $gray;
        cursor: pointer;
    }
</style>
